class CouponCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const spanElement = this.querySelector('span');
    if (spanElement) {
      const originalText = spanElement.innerText;
      navigator.clipboard.writeText(originalText).then(() => {
        spanElement.innerText = 'COPIED';
        setTimeout(() => {
          spanElement.innerText = originalText;
        }, 2000);
      }).catch(err => {
          console.error('Failed to copy text:', err);
      });
    } else {
      console.error('No span found inside the custom element.');
    }
  }
}

customElements.define('coupon-code', CouponCode);
